module.exports = __webpack_public_path__ + "stylesheets/text-block_055c7a9171f9845cac6237a45ac63e82.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/text-block.less
// module id = eCEw
// module chunks = 153